import styled from 'styled-components';

export const Container = styled.div`
  > .ant-input-search {
    margin-bottom: 20px;
  }
`;

export const GroupTitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  svg {
    cursor: pointer;
  }
`;
